var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("数据导出"),
      visible: _vm.showVisible,
      width: 700,
      footer: null,
      maskClosable: false,
      closable: false
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-spin", {
    attrs: {
      spinning: _vm.exportLoading
    }
  }, [_c("a-form", {
    attrs: {
      form: _vm.form,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 16
      }
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("保单归属")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单归属"),
      "show-search": "",
      "option-filter-prop": "label"
    },
    on: {
      change: _vm.changeCustomerId
    },
    model: {
      value: _vm.form.customerId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "customerId", $$v);
      },
      expression: "form.customerId"
    }
  }, _vm._l(_vm.customerList2, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id,
        label: item.name
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.name
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("保单号"),
      required: "",
      prop: "policyNo"
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("请选择") + _vm.$t("保单号")
    },
    model: {
      value: _vm.form.policyNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyNo", $$v);
      },
      expression: "form.policyNo"
    }
  }, _vm._l(_vm.policyNoList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.policyNo
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: item.policyNo
      }
    }, [_vm._v(" " + _vm._s(item.policyNo) + " ")])], 1);
  }), 1)], 1), _c("a-form-item", {
    attrs: {
      label: _vm.$t("批改时间"),
      required: "",
      prop: "time"
    }
  }, [_vm.showVisible ? _c("a-range-picker", {
    attrs: {
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.form.time,
      callback: function ($$v) {
        _vm.$set(_vm.form, "time", $$v);
      },
      expression: "form.time"
    }
  }) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "btn-box"
  }, [_vm.isAuth("home.personnelDetailsRecordCheckEndorsementExport") || _vm.isAuth("home.personnelDetailsRecordEndorsementExport") || _vm.isAuth("home.personnelDetailsRecordEndorsementExportSend") ? _c("div", {
    staticClass: "detail-icon border-right-class"
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("批单")))]), _c("a-icon", {
    staticStyle: {
      "font-size": "45px",
      margin: "20px 0"
    },
    attrs: {
      type: "file-text"
    }
  }), _c("div", [_vm.isAuth("home.personnelDetailsRecordCheckEndorsementExport") ? _c("a-button", {
    on: {
      click: _vm.preview
    }
  }, [_vm._v(_vm._s(_vm.$t("预览批单")))]) : _vm._e(), _c("a-dropdown", {
    scopedSlots: _vm._u([{
      key: "overlay",
      fn: function () {
        return [_c("a-menu", {
          on: {
            click: _vm.handleMenuClick
          }
        }, [_vm.isAuth("home.personnelDetailsRecordEndorsementExport") ? _c("a-menu-item", {
          key: "create"
        }, [_vm._v(_vm._s(_vm.$t("生成批单")))]) : _vm._e(), _vm.isAuth("home.personnelDetailsRecordEndorsementExportSend") ? _c("a-menu-item", {
          key: "createAndSend"
        }, [_vm._v(_vm._s(_vm.$t("生成并发送")))]) : _vm._e()], 1)];
      },
      proxy: true
    }], null, false, 2462424099)
  }, [_vm.isAuth("home.personnelDetailsRecordEndorsementExport") || _vm.isAuth("home.personnelDetailsRecordEndorsementExportSend") ? _c("a-button", {
    staticClass: "marginL15"
  }, [_vm._v(" " + _vm._s(_vm.$t("生成批单")) + " "), _c("a-icon", {
    attrs: {
      type: "down"
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "detail-icon"
  }, [_c("span", {
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("增减员明细")))]), _c("a-icon", {
    staticStyle: {
      "font-size": "45px",
      margin: "20px 0"
    },
    attrs: {
      type: "file-excel"
    }
  }), _c("div", [_c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.onExport
    }
  }, [_vm._v(_vm._s(_vm.$t("导出明细")))])], 1)], 1)]), _c("div", {
    staticClass: "btns"
  }, [_c("a-button", {
    on: {
      click: _vm.close
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 1)], 1), _c("a-modal", {
    staticClass: "reduce-modal",
    attrs: {
      title: _vm.$t("信息提示"),
      visible: _vm.tipVisible,
      width: 700,
      cancelText: _vm.requestInfo.type === "createAndSend" && _vm.loading === false ? _vm.$t("立即查看") : "",
      okText: _vm.$t("关闭"),
      closable: false,
      maskClosable: false,
      cancelButtonProps: _vm.requestInfo.type === "create" || _vm.requestInfo.type === "preview" || _vm.loading === true || _vm.importStatus !== "SUCCESS" ? {
        style: {
          display: "none"
        }
      } : {}
    },
    on: {
      cancel: _vm.tipChange,
      ok: function ($event) {
        _vm.tipVisible = false;
        _vm.loading = false;
      }
    }
  }, [_vm.loading ? _c("div", {
    staticClass: "example"
  }, [_c("a-spin", {
    attrs: {
      tip: _vm.$t(_vm.requestInfo.loadingTip)
    }
  })], 1) : _c("div", {
    staticClass: "complete-tip"
  }, [_c("a-icon", {
    class: _vm.importStatus === "SUCCESS" ? "complate-icon" : "error-icon",
    attrs: {
      type: "check-circle"
    }
  }), _c("div", {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.importStatus === "SUCCESS" ? _vm.$t("生成成功") : _vm.$t("生成失败")))])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };